// Checkout & cart: company/shipping fields, login popup, shipping/payment updates,
// coupons/giftcards and the cart carousel add-to-cart.
export default function () {

    const $ = jQuery;

    $('#billing_company_field').hide();
    $('#woocommerce_eu_vat_number').hide();

    $('#company-checkout').on('change', function () {
        if ($(this).is(':checked')) {
            // Move from hidden container to shipping_checkout div
            $('#billing_company_field').show();
            $('#woocommerce_eu_vat_number').show();
        } else {
            $('#billing_company_field').hide();
            $('#woocommerce_eu_vat_number').hide();
        }
    });

    $('#ship-to-different-address-checkbox').on('change', function () {

        if ($('#ship-to-different-address-checkbox').is(':checked')) {
            // CHECKED => show shipping fields (move into visible container)
            $('#shipping_title').show();
            $('#billing_title').text('Factuuradres');
            $('.hidden_shipping_fields').children().appendTo('[data-function="shipping_checkout"]');
        } else {
            // UNCHECKED => hide shipping fields (move back to storage)
            $('[data-function="shipping_checkout"]').children().appendTo('.hidden_shipping_fields');
            $('#shipping_title').hide();
            $('#billing_title').text('Factuur- en verzendadres');
        }
    });

    $('[data-action="toggle_login_popup"]').on('click', function () {

        $('.wc__checkout-overlay').toggleClass('is-active');
        $('.wc__checkout-popup').toggleClass('is-active');

    });

    $('.wc__checkout-overlay').on('click', function () {

        $('.wc__checkout-popup').toggleClass('is-active');
        $('.wc__checkout-overlay').toggleClass('is-active');

    });

    $(document).on('select2:select', '#billing_country', function (e) {

        let country = $('#billing_country').val();

        $('.wc__checkout-paymentoptions').addClass('updating');

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                country: country,
                action: 'update_shipping_payment_prices',
            },
            beforeSend: function () {
                $('.wc__checkout-paymentoptions').addClass('updating');
            },
            success: function (response) {
                if (response.success) {
                    // ('.wc__checkout-paymentoptions').html(response.data.checkout);
                    location.reload(); // Reload is better
                }
            },
        });

    });

    function updateCart() {
        let shippingInput = $('input[name^="shipping_method"]:checked').val();
        let paymentInput = $('input[name="payment_method"]:checked').val();

        if (!shippingInput) {

            shippingInput = $('#shipping_method_0').val();

        }

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'update_checkout_prices',
                shipping: shippingInput,
                payment: paymentInput,
            },
            beforeSend: function () {
                $('.wc__checkout-total').addClass('updating');
            },
            success: function (response) {
                if (response.success) {
                    $('.wc_checkout-total-content').html(response.data.checkout);
                }
            },
            complete: function () {
                $('.wc__checkout-total').removeClass('updating');
            }
        });
    }

    $(document).on('change', 'input[name^="shipping_method"]', function () {

        updateCart();

    });

    $(document).on('change', 'input[name="payment_method"]', function () {

        updateCart();

    });


    // Carousel "in winkelwagen" — alleen aanwezig op de winkelwagen-pagina.
    // Voegt het product direct toe en ververst de cart-sectie zonder paginalading.
    $(document).on('click', '[data-action="cart_carousel_add_to_cart"]', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const productId = $btn.data('product-id');

        if (!productId || $btn.hasClass('is-loading')) return;

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'carousel_add_to_cart',
                product_id: productId,
            },
            beforeSend: function () {
                $btn.addClass('is-loading');
            },
            success: function (response) {
                if (response.success) {
                    $('.wc__cart').replaceWith(response.data.cart_html);
                }
            },
            complete: function () {
                $btn.removeClass('is-loading');
            },
        });
    });


    $(document).on('click', '[data-action="wc-toggle-coupons"]', function () {

        $(this).toggleClass('is-active');
        $('.wc__checkout-giftcard-container').toggleClass('is-active');

    });

    $(document).on('click', '[data-action="wc-remove-giftcard"]', function () {

        let couponId = $(this).data('couponid');

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                couponid: couponId,
                action: 'remove_coupon_checkout',
            },
            success: function (response) {
                if (response.success) {
                    updateCart();

                    $('.wc__checkout-giftcard').html(response.html);
                    $('.wc__checkout-giftcard-container').addClass('is-active');

                }
            },
        });

    });


    $(document).on('click', '[data-action="wc-add-giftcard"]', function () {

        let couponcode = $('#custom-checkout-input').val();
        $('.wc__checkout-giftcard-error').hide();

        if (!couponcode) {
            $('.wc__checkout-giftcard-error').text('Coupon veld kan niet leeg zijn').show();
            return;
        }

        // If no content, make AJAX call to load the gift card form
        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                couponcode: couponcode,
                action: 'add_coupon_checkout',
            },
            success: function (response) {
                if (response.success) {
                    updateCart();

                    $('.wc__checkout-giftcard').html(response.html);
                    $('.wc__checkout-giftcard-container').addClass('is-active');

                } else {
                    $('.wc__checkout-giftcard-error').text('Coupon is ongeldig').show();
                    return;
                }
            },
        });

    });

}
